document.addEventListener('DOMContentLoaded', () => {
  const catalogPasswordButton = document.getElementById('CatalogPasswordButton');
  if(catalogPasswordButton) {
    catalogPasswordButton.addEventListener('click', () => {
      const catalogPasswordInput = document.getElementById('CatalogPassword');
      if(catalogPasswordInput.value == 'NaturalToys') {
        document.querySelector('.password-overlay--inner').remove();
        document.querySelector('.loader-container').style = "";
        setTimeout(() => {
          document.querySelector('.password-overlay').remove();
          document.querySelector('.collage-builder--custom').style ="";
          document.querySelector('.main-page-container').remove();
        }, "1500");
      }
      else {
        document.querySelector('.password-error-wrapper').classList.add('visible');
      }
    });
  }
});